import React, { ReactElement, useState } from 'react';
import './Main.scss';

import { Link } from 'react-router-dom';
import Rules from '../../components/Rules/Rules';
import Winners from '../../components/winners/Winners';
import Register from '../../components/register/Register';
import { useTranslation } from 'react-i18next';

const Main: React.FC = (): ReactElement => {
  const { t } = useTranslation();
  const [showRegister, setShowRegister] = useState<boolean>(false);
  const [showRegisterCloseBtn, setShowRegisterCloseBtn] =
    useState<boolean>(false);

  return (
    <div className="Main">
      <section className="banner">
        <div className="banner-margins">
          <div className="columns">
            <div className="banner-header column is-full-desktop">
              {/* <p>
                <span className="block-span">
                  Osta mis tahes Tutti Frutti komme, registreeri ostutšekk
                  kampaanialehel ja võida auhindu!
                </span>{' '}
                <span className="block-span secondary">
                  Loosis on 2 glämpingutelki ja 4 JBL Charge 5 kaasaskantavat
                  kõlarit.
                </span>
              </p>
              <div className="campaign-period">
                <span>{t('campaign period')}</span>
              </div> */}
              <Link
                to="#register"
                onClick={() => setShowRegister(true)}
                className="button desktop"
              >
                {t('register')}
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="header">
        <Header />
      </section> */}
      {/* <div className="mobile-btn">
        <Link
          to="#register"
          onClick={() => setShowRegister(true)}
          className="button mobile"
        >
          {t('register')}
        </Link>
      </div> */}

      <section className="register-form">
        {showRegister ? (
          <div className="container">
            {showRegisterCloseBtn ? (
              <button
                onClick={() => setShowRegister(false)}
                className="close-button"
              >
                &times;
              </button>
            ) : (
              ''
            )}
            <div className="columns">
              <div className="column">
                <Register stateChanger={setShowRegisterCloseBtn} />
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </section>
      <section className="rules-section" id="rules">
        <div className="container">
          <Rules />
        </div>
      </section>
      <section className="winners-section" id="winners">
        <div className="container">
          <Winners />
        </div>
      </section>
    </div>
  );
};

export default Main;
